<style>
    /*.form-container{*/
        /*width:500px;*/
    /*}*/
</style>

<template>
    <Modal
            v-model="showModal"
            :title="title"
            :loading="true"
            :styles="{top: '20px',width:'900px'}"
    >
        <div slot="footer">
            <Button type="text" size="large" @click="modalCancel">取消</Button>
            <Button type="primary" size="large" @click="handleSubmit('roleForm')" :loading="saving">确定</Button>
        </div>
        <Form :model="formItem" :rules="ruleValidate" :label-width="80" ref="roleForm">
            <FormItem label="角色名称" prop="name" >
                <Input v-model="formItem.name" placeholder="" style="width:260px"></Input>
            </FormItem>
            <FormItem label="角色代码" prop="code" >
                <Input v-model="formItem.code" placeholder="" style="width:260px"></Input>
            </FormItem>
            <FormItem label="状态" prop="state">
                <Select v-model="formItem.state" style="width:260px">
                    <Option :value="1" label="正常" ></Option>
                    <Option :value="0" label="禁用"></Option>
                </Select>
            </FormItem>
            <FormItem label="排序" prop="sort" >
                <Input v-model="formItem.sort" placeholder="" style="width:260px"></Input>
            </FormItem>
            <FormItem label="权限" >
                <table class="tb1" cellpadding="0" cellspacing="0" id="permissionset">
                    <template v-for="permission in permissionData">
                        <tr>
                            <td style="width:100px;">
                                <Checkbox @on-change="changePerm(permission.has,permission.id,1)" :true-value="1" :false-value="0" v-model="permission.has">{{permission.name}}</Checkbox>
                            </td>
                            <td>
                                <table class="noborder">
                                    <template v-for="permission2 in permission.permissionList">
                                        <tr>
                                            <td class="thick" style="width:120px;">
                                                <Checkbox @on-change="changePerm(permission2.has,permission2.id,2)" :true-value="1" :false-value="0" v-model="permission2.has">{{permission2.name}}</Checkbox>
                                            </td>
                                            <template v-for="permission3 in permission2.permissionList">
                                                <td>
                                                    <Checkbox @on-change="changePerm(permission3.has,permission3.id,3)" :true-value="1" :false-value="0" v-model="permission3.has">{{permission3.name}}</Checkbox>
                                                </td>
                                            </template>
                                        </tr>
                                    </template>
                                </table>
                            </td>
                        </tr>
                    </template>
                </table>
            </FormItem>

        </Form>
    </Modal>
</template>

<script>
    import * as RoleApi from '@/api/role.js';
    import * as PermissionApi from '@/api/permission.js';
    export default {
        name: 'RoleForm',
        data(){
            return {
                title:'',
                showModal:false,
                pageName: this.$route.name,
                saving:false,
                formItem: {
                    id:'',
                    name: '',
                    code: '',
                    state: 1,
                    sort:null,
                },
                permissionData:null,
                ruleValidate: {
                    name: [
                        { required: true, message: '请输入角色名称', trigger: 'blur' }
                    ],
                    state:[
                        { type:'integer', trigger: 'blur' }
                    ],
                    sort:[
                        { type:'number', message: '请输入数字', trigger: 'blur',transform(value) {
                            return Number(value);
                        }}
                    ]
                }
            }
        },
        methods:{
            changePerm(val,id,level){
                if (level == 1){
                    this.permissionData.every(function (perm) {
                        if (perm.id == id){
                            perm.permissionList && perm.permissionList.every(function(perm2){
                                perm2.has = val;
                                perm2.permissionList && perm2.permissionList.every(function(perm3){
                                    perm3.has = val;
                                    return true
                                })
                                return true
                            })
                            return false
                        }
                        return true
                    })
                }else if (level == 2){
                    this.permissionData.every(function (perm) {
                        let parenthas = 0;
                        let isperm1 = false;
                        perm.permissionList && perm.permissionList.every(function(perm2){
                            if (perm2.id == id){
                                isperm1 = true;
                                if (val == 1){
                                    parenthas = 1;
                                    perm2.permissionList && perm2.permissionList.every(function(perm3){
                                        perm3.has = 1;
                                        return true
                                    })
                                }else{
                                    perm2.permissionList && perm2.permissionList.every(function(perm3){
                                        perm3.has = 0;
                                        return true
                                    })
                                }
                            }
                            if (perm2.has){
                                parenthas = 1;
                                if (isperm1){
                                    return false
                                }else{
                                    return true
                                }
                            }else{
                                return true
                            }

                        })
                        if (isperm1){
                            perm.has = parenthas;
                            return false
                        }else{
                            return true
                        }
                    })
                }else if (level == 3){

                }

            },
            packagingFormData(){
                let postFormData = {};
                for (var i in this.formItem) {
                    if (this.formItem.hasOwnProperty(i)) {
                        postFormData['role.'+i] = this.formItem[i];
                    }
                }
                let permArray = [];
                this.permissionData && this.permissionData.forEach(function(perm1){
                    if (perm1.has){
                        permArray.push(perm1.id);
                    }
                    perm1.permissionList && perm1.permissionList.forEach(function(perm2){
                        if (perm2.has){
                            permArray.push(perm2.id);
                        }
                        perm2.permissionList && perm2.permissionList.forEach(function(perm3){
                            if (perm3.has){
                                permArray.push(perm3.id);
                            }
                        });
                    });
                });
                postFormData['permIds'] = permArray.join(",");
                return postFormData;
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            },
            modalCancel (){
                this.showModal = false;
                this.$refs['roleForm'].resetFields();
            },
            handleSubmit (name) {
                let self = this;
                self.$refs[name].validate((valid) => {
                    try{
                        if (valid) {
                            try{
                                self.saving = true;
                                self.$api.role.save(self.packagingFormData()).then(resp => {
                                    if (resp.state == 'ok'){
                                        self.$Message.info({
                                            content:'提交成功',
                                            onClose (){
                                                self.showModal = false;
                                            }
                                        });
                                        self.$emit('close');
                                    }else{
                                        self.saving = false;
                                        self.$Message.error(resp.msg);
                                    }
                                });
                            }catch (err){
                                console.log(err);
                            }

                        } else {
                            this.$Message.error('表单校验不通过');
                        }
                    }catch(err){
                        console.log(err);
                    }

                })
            },
            handleFormatError (file) {
                this.$Message.error('格式不正确');
            },
            loadInfo(id,callback){
                this.$api.role.getOne({id:id}).then(resp => {
                    if (resp.state == 'ok'){
                        this.formItem.id = resp.data.id;
                        this.formItem.name = resp.data.name;
                        this.formItem.code = resp.data.code;
                        this.formItem.state = resp.data.state;
                        this.formItem.sort = resp.data.sort;
                        this.$api.perm.getPermissionList({roleId:id}).then(resp => {
                            if (resp.state == 'ok'){
                                this.permissionData = resp.data;
                            }
                            callback && callback();
                        });
                    }
                });
            },
            showWin(roleId){
                let self = this;
                self.saving = false;

                this.formItem.id = null;
                this.formItem.name = '';
                this.formItem.code = '';
                this.formItem.state = null;
                this.formItem.sort = null;
                this.permissionData = [];

                self.$refs['roleForm'].resetFields();
                if (roleId){
                    self.title = '修改';
                    self.loadInfo(roleId,function(){
                        self.showModal = true;
                    });
                }else{
                    self.title = '新增';
                    this.$api.perm.getPermissionList().then(resp => {
                        if (resp.state == 'ok'){
                            self.permissionData = resp.data;
                        }
                        self.showModal = true;
                    });

                }
            }
        }
    }
</script>
